(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .directive('birthDateDatetimePicker', BirthDateDatetimePickerDirective);

    function BirthDateDatetimePickerDirective(moment) {
        var format = "DD/MM/YYYY";

        return {
            restrict: "A",
            require: "ngModel",
            link: function (scope, element, attrs, ctrl) {
                element.datetimepicker({
                    format: format,
                    sideBySide: true,
                    ignoreReadonly: true,
                    locale: moment.locale(),
                    allowInputToggle: true,
                    showClear: true,
                    maxDate: moment(),
                });

                ctrl.$formatters.push(function (value) {
                    if (value) {
                        var date = moment.utc(value);
                        if (date.isValid()) {
                            return date.format(format);
                        }
                        return "";
                    }
                    return undefined;
                });

                element.on("dp.change", function (ev) {
                    scope.$apply(function () {
                        if (ev.date) {
                            ctrl.$setViewValue(moment(ev.date).format(format));
                        } else {
                            ctrl.$setViewValue(null);
                        }
                    });
                });
            },
        };
    }
})();
